module.exports = __webpack_public_path__ + "img/9.3eb05bf2.png";